var map = {
	"./controls": 10,
	"./controls.coffee": 10,
	"./feedback": 11,
	"./feedback.coffee": 11,
	"./import": 21,
	"./import.coffee": 21,
	"./import_google": 22,
	"./import_google.coffee": 22,
	"./index": 12,
	"./index.coffee": 12,
	"./preset": 23,
	"./preset.coffee": 23,
	"./setup": 24,
	"./setup.coffee": 24,
	"./welcome": 25,
	"./welcome.coffee": 25
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;



/*****************
 ** WEBPACK FOOTER
 ** ./app/views/register ^\.\/.*$
 ** module id = 50
 ** module chunks = 0
 **/